import { ICarComparisonStore, MAX_LIMIT } from '.';
import { filterEmptyValues } from '../../../foundation/helpers';

interface IComparisonStoreGetters {
  vehicleIdsInCart: (state: ICarComparisonStore) => string[];
  hasReachedMaxLimit: (state: ICarComparisonStore) => boolean;
  isCurrentlySelected: (state: ICarComparisonStore) => (vehicleId: string) => boolean;
  maxLimit: (state: ICarComparisonStore) => number;
  fetchedVehiclesCount: (state: ICarComparisonStore) => number;
  carsToCompare: (state: ICarComparisonStore) => any[];
  getComparedCarMakes: (state: ICarComparisonStore) => string[];
  getCarYearRange: (state: ICarComparisonStore) => (vehicleId: string) => string;
}

export const getters: IComparisonStoreGetters = {
  vehicleIdsInCart: (state) => {
    return filterEmptyValues(state.selectedVehicleIds);
  },
  hasReachedMaxLimit: (state) => {
    return filterEmptyValues(state.selectedVehicleIds).length === MAX_LIMIT;
  },
  isCurrentlySelected: (state) => {
    return (vehicleId: string) => filterEmptyValues(state.selectedVehicleIds).indexOf(vehicleId) >= 0;
  },
  maxLimit: () => {
    return MAX_LIMIT;
  },
  fetchedVehiclesCount: (state) => {
    return Object.keys(state.fetchedVehicles).length;
  },
  carsToCompare(state) {
    return state.selectedVehicleIds.map((id: string) => {
      if (!id) return undefined;
      return state.fetchedVehicles[id];
    });
  },
  getComparedCarMakes(state) {
    const carMakes = filterEmptyValues(
      state.selectedVehicleIds.map((id: string) => {
        return state.fetchedVehicles[id]?.Make ?? undefined;
      })
    );

    return Array.from(new Set(carMakes));
  },
  getCarYearRange(state) {
    return (vehcileId: string) => {
      if (vehcileId && state.fetchedVehicles[vehcileId]) {
        const carData = state.fetchedVehicles[vehcileId];
        let range = '';

        if (carData.Status === 'current') return 'CURRENT MODEL';

        if (carData?.Year_low && carData?.Year_high) {
          if (carData.Year_low === carData.Year_high) {
            return carData.Year_low;
          }

          return `${carData.Year_low} - ${carData.Year_high}`;
        }

        if (carData?.Year_low) {
          range += carData.Year_low;
        } else if (carData?.Year_high) {
          range += carData.Year_high;
        } else {
          range = 'No year data';
        }

        return range;
      }

      return 'Error fetching year data';
    };
  },
};
